import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { LK_PROFILE_ROUTES as ROUTES } from './utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'profile',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.INDEX },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "lk-profile.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'ViewLKProfileLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.INDEX,
        component: (): PromiseVue => import(
          /* webpackChunkName: "lk-profile.index" */
          './LKProfileIndex.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
